import { gql } from '@apollo/client';

export const PROPOSAL = gql`
  query Proposal($id: ID!) {
    proposal(id: $id) {
      id
      orderId
      contractorId
      userId
      siteVisitId
      planId
      mapResultId
      mapResult {
        id
        snapshot
        map
      }
      plan {
        id
        title
        meta
        planSVG
        planId
        photos
      }
      contractor {
        id
        name
      }
      price
      currency
      comment
      timeline {
        from
        to
        unit
      }
      estimate {
        total
      }
      formPayload
      executionTimeframe
      validUntil
      payload
      notes
      status
      createdAt
      updatedAt
    }
  }
`;

export const ORDER_PROPOSALS = gql`
  query OrderProposals($orderId: ID!) {
    orderProposals(orderId: $orderId) {
      id
      orderId
      contractorId
      userId
      siteVisitId
      planId
      mapResultId
      mapResult {
        id
        snapshot
        map
      }
      contractor {
        id
        name
      }
      price
      currency
      comment
      timeline {
        from
        to
        unit
      }
      estimate {
        total
      }
      formPayload
      executionTimeframe
      validUntil
      payload
      notes
      status
      createdAt
      updatedAt
    }
  }
`;

export const MY_PROPOSALS = gql`
  query MyProposals {
    myProposals {
      id
      orderId
      contractorId
      userId
      siteVisitId
      planId
      mapResultId
      mapResult {
        id
        snapshot
        map
      }
      price
      currency
      comment
      timeline {
        from
        to
        unit
      }
      estimate {
        total
      }
      formPayload
      executionTimeframe
      validUntil
      payload
      notes
      status
      createdAt
      updatedAt
    }
  }
`;

export const PROPOSALS = gql`
  query Proposals {
    proposals {
      id
      orderId
      contractorId
      userId
      siteVisitId
      planId
      mapResultId
      mapResult {
        id
        snapshot
        map
      }
      price
      currency
      comment
      timeline {
        from
        to
        unit
      }
      estimate {
        total
      }
      formPayload
      executionTimeframe
      validUntil
      payload
      notes
      status
      createdAt
      updatedAt
    }
  }
`;
